import { render, staticRenderFns } from "./RealtimeSummary.vue?vue&type=template&id=16a6364f&"
import script from "./RealtimeSummary.vue?vue&type=script&lang=js&"
export * from "./RealtimeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports